import { Flex, Text } from "@/atoms"
import { FeatureStatusTag } from "./FeatureStatusTag"

import styles from "./FeatureStatusTag.module.scss"

import type { LabelFeatureStatusTagProps } from "."

export const LabelFeatureStatusTag = (props: LabelFeatureStatusTagProps) => {
  const { label, justify, gap = 8, flex = 1, align = "center", ...rest } = props

  return (
    <Flex flex={flex} gap={gap} align={align} justify={justify}>
      {typeof label === "string" ? <Text>{label}</Text> : label}
      <FeatureStatusTag className={styles.labelTag} {...rest} />
    </Flex>
  )
}
